import {
    AbstractMapLayerProviderListFormModel,
    MapLayerProviderListFormModelOptions,
} from 'app/overview/config/configuration_tab/general/frontend_config/common/AbstractMapLayerProviderListFormModel';
import { ImsImageryProvider } from 'app/config/ImsImageryProvider';
import { ImageryProviderFormModel } from 'app/overview/config/configuration_tab/general/frontend_config/imagery/ImageryProviderFormModel';
import { ImsImageryProviderList } from 'app/config/ImsImageryProviderList';
import {
    FrontEndConfigFormField,
    FrontEndConfigFormModel,
} from 'app/overview/config/configuration_tab/general/frontend_config/FrontEndConfigFormModel';
import { MapLayerOptionsHelper } from 'app/overview/config/data/MapLayerOptionsHelper';

interface ImageryProviderListFormModelOptions
    extends MapLayerProviderListFormModelOptions<ImsImageryProvider, ImageryProviderFormModel> {
    // Provides the definitions for the imagery layers
    mapOptionsHelper?: MapLayerOptionsHelper;
}

export class ImageryProviderListFormModel extends AbstractMapLayerProviderListFormModel<
    ImsImageryProvider,
    ImsImageryProviderList,
    ImageryProviderFormModel
> {
    private _mapOptionsHelper: MapLayerOptionsHelper;

    constructor(
        frontEndConfigFormModel: FrontEndConfigFormModel,
        formField: FrontEndConfigFormField,
        options: ImageryProviderListFormModelOptions = {},
    ) {
        super(frontEndConfigFormModel, formField, options);
        if (!options.mapOptionsHelper) {
            throw new Error(`options.mapOptionsHelper must be truthy`);
        }
        this._mapOptionsHelper = options.mapOptionsHelper;
    }

    protected createMapLayerListProviderFromValueUnderEdit(): ImsImageryProviderList {
        return new ImsImageryProviderList(
            this._providerFormModels.map((m) => m.valueUnderEdit.clone()),
        );
    }

    protected createProviderFormModel(
        origValue: ImsImageryProvider,
        valueUnderEdit: ImsImageryProvider,
    ): ImageryProviderFormModel {
        return new ImageryProviderFormModel(
            this,
            origValue,
            valueUnderEdit,
            this._mapOptionsHelper,
        );
    }

    /**
     * Create a new provider, blank details
     */
    addNewProvider(): void {
        const newFormModel = this._createProviderFormModel(
            null,
            new ImsImageryProvider(null, this._mapOptionsHelper),
        );
        newFormModel.setExpanded(true);
        this._providerFormModels.push(newFormModel);
        this._notifyListeners();
    }
}
